import { Component, Input, OnInit } from '@angular/core';

import { getMembershipIntervalDisplaySingle, Membership, MembershipUpfrontPaymentOption } from '../../../../../../../../models/membership';
import { MembershipDiscountType } from '../../../../../../../../models/membership-enums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { deleteProp, propExists, propExistsAndIsNonEmpty } from '../../../../../../../../utils';


@Component({
  selector: 'app-add-membership-upfront-payment-option-modal',
  templateUrl: './add-membership-upfront-payment-option-modal.component.html',
  styleUrls: ['./add-membership-upfront-payment-option-modal.component.css']
})
export class AddMembershipUpfrontPaymentOptionModalComponent implements OnInit {
  @Input() membership: Membership;
  @Input() existingOption: MembershipUpfrontPaymentOption;
  @Input() completedCallback: (result: MembershipUpfrontPaymentOption) => undefined;

  public upfrontPaymentOption: MembershipUpfrontPaymentOption = {
    number_of_periods: null,
    discount_amount: null,
    discount_type: MembershipDiscountType.currency,
  };
  public enableMinTimeWithoutActiveOrFrozenMembershipDays = false;

  public readonly MembershipDiscountType = MembershipDiscountType;
  public readonly getMembershipIntervalDisplaySingle = getMembershipIntervalDisplaySingle;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService,
  ) {}

  ngOnInit() {
    if (this.existingOption) {
      this.upfrontPaymentOption = {...this.existingOption};
    }
    if (propExists(this.upfrontPaymentOption.min_time_without_active_or_frozen_membership_days)) {
      this.enableMinTimeWithoutActiveOrFrozenMembershipDays = true;
    }
  }

  public errorMessage(): string | null {
    if (!this.allInputsProvided()) { return null; }

    if (this.upfrontPaymentOption.number_of_periods <= 1) {
      return 'The number of periods must be greater than 1.';
    }
    if (this.upfrontPaymentOption.discount_amount < 0) {
      return 'The discount amount may not be negative.';
    }
    const startDate = this.upfrontPaymentOption.available_start_date;
    const endDate = this.upfrontPaymentOption.available_end_date;
    if (propExistsAndIsNonEmpty(startDate) && propExistsAndIsNonEmpty(endDate) && endDate < startDate) {
      return 'The end date cannot be before the start date.';
    }
    for (const upo of this.membership.upfront_payment_options) {
      if (this.existingOption && (upo.number_of_periods === this.existingOption.number_of_periods)) {
        continue;
      }
      if (upo.number_of_periods === this.upfrontPaymentOption.number_of_periods) {
        return 'There is already an upfront payment option with this number of periods.';
      }
    }

    return null;
  }

  public inputsValid(): boolean {
    return (
      this.allInputsProvided() &&
      (this.errorMessage() === null)
    );
  }

  public handleSubmit() {
    if (!this.enableMinTimeWithoutActiveOrFrozenMembershipDays) {
      this.upfrontPaymentOption.min_time_without_active_or_frozen_membership_days = undefined;
    }

    for (const dateProp of ['available_start_date', 'available_end_date']) {
      if (!propExistsAndIsNonEmpty(this.upfrontPaymentOption[dateProp])) {
        deleteProp(this.upfrontPaymentOption, dateProp);
      }
    }

    this.completedCallback(this.upfrontPaymentOption);

    this.activeModal.close();
  }

  private allInputsProvided(): boolean {
    return (
      !!this.upfrontPaymentOption.number_of_periods &&
      propExists(this.upfrontPaymentOption.discount_amount) &&
      !!this.upfrontPaymentOption.discount_type
    );
  }
}
